module.exports = __webpack_public_path__ + "static/media/logo.b106a003.svg";